export const actions: any = [
  {
    title: 'Configure Report',
    action: 'configure',
    hidden: false,
    icon: 'configure-report-action-icon',
  },
];
